// defines "analytics" (Segment) & "Bugsnag" as undefined
// in the case that the scripts fail at loading.  variable
// needs to be set to undefined to avoid a reference error
// when detecting their state before firing events
var analytics = analytics || undefined;
var Bugsnag = Bugsnag || undefined;
var ga = ga || undefined;

/* global: _ , moment */

// namespace for all analytics integrations
var analyticsIntegrations = {};

analyticsIntegrations.getGoogleAnalyticsID = function() {
  var currClientID;
  if (!ga) {
    currClientID = null;
  } else {
    ga(function(tracker) { currClientID = tracker.get('clientId'); });
  }
  return currClientID;
};

// checks segment state
analyticsIntegrations.segmentLoaded = function() {
  var isDefined = analytics ? true : false;
  return isDefined;
};

analyticsIntegrations.mergeObject = function(obj, objToAdd){
  for (var attrname in objToAdd) {
    if (objToAdd.hasOwnProperty(attrname)) {
      obj[attrname] = objToAdd[attrname];
    }
  }
  return obj;
};

// checks bugsnag state
analyticsIntegrations.bugsnagLoaded = function() {
  var isDefined = Bugsnag ? true : false;
  return isDefined;
};

// identifies version & env for bugsnag
analyticsIntegrations.bugsnagDetails = function() {
  if (!analyticsIntegrations.bugsnagLoaded()) {return;}
  // Bugsnag.appVersion = version;
  // Bugsnag.releaseStage = env;
};

analyticsIntegrations.pageUrl = function(){
  if (!analyticsIntegrations.segmentLoaded()) {return;}
  var page;
  var locationPath = location.pathname;
  page = locationPath.replace("/app/", "").replace("/","");
  return page;
};

analyticsIntegrations.getOrigin = function () {
  var origin;
  if (document.referrer === (location.origin + '/')) {
    origin = 'home';
  } else if (-1 !== document.referrer.indexOf('/s/')) {
    origin = 'search';
  } else if (-1 !== document.referrer.indexOf('/u/')) {
    origin = 'use type';
  } else if (-1 !== document.referrer.indexOf('/venues/')) {
    slashCount = document.referrer.split('/').length;
    origin = 5 < slashCount ? 'keyword' : 'city';
  } else if (-1 !== document.referrer.indexOf('/featured/')) {
    origin = 'collection';
  } else {
    origin = document.referrer;
  }
  return origin;
};

analyticsIntegrations.normalizeBookingObj = function (booking) {
  var pickedArray = [
    'guest_payment_amount',
    'guest_payment_processing_fee',
    'guest_payment_processing_fee_percent',
    'guest_subtotal_payment_amount',
    'host_payout_amount',
    'host_payout_processing_fee',
    'host_payout_processing_fee_percent',
    'subtotal_amount',
    'base_subtotal',
    'sales_tax',
    'sales_tax_percent',
    'gratuity',
    'gratuity_percent',
    'after_midnight',
    'duration',
    'guest_id',
    'number_of_guests',
    'dts_start',
    'dts_end',
    'dts_expires'
  ];

  var normalizeBookingObj = _.assign({}, _.pick(booking, pickedArray));
  normalizeBookingObj.value = booking.guest_payment_amount;
  // cleaning fee
  const addtlCharges = _.get(booking, 'addtl_charges', []);
  var cleaningFee = _.find(addtlCharges, function (charge) {
    return 'CLEANING_FEE' === charge.type;
  });

  normalizeBookingObj.display_date = _.get(booking, 'start.display.date');
  normalizeBookingObj.display_start = _.get(booking, 'start.display.time');
  normalizeBookingObj.display_end = _.get(booking, 'end.display.time');

  normalizeBookingObj.cleaning_fee_set = !!cleaningFee;
  normalizeBookingObj.cleaning_fee_amount = _.get(cleaningFee, 'value');
  // day rate discount
  var dayRateDiscount = _.find(booking.discounts, function (discount) {
    return 'DAY_RATE_DISCOUNT' === discount.type;
  });
  normalizeBookingObj.day_rate_set = !!dayRateDiscount;
  normalizeBookingObj.day_rate_amount = _.get(dayRateDiscount, 'discount_amount');
  normalizeBookingObj.day_rate_percent = _.get(dayRateDiscount, 'value');
  // duration
  normalizeBookingObj.day_count = _.get(booking, 'daily_durations', []).length;
  // booking basics
  normalizeBookingObj.booking_id = _.get(booking, 'booking_id') || _.get(booking, '_id');
  normalizeBookingObj.booking_status = _.get(booking, 'obj_state');
  normalizeBookingObj.is_instant_booking = !!booking.is_instant_booking;
  // variable pricing
  normalizeBookingObj.bkg_has_price_by_day = _.get(booking, 'rate_details.is_rate_variable', false);
  normalizeBookingObj.bkg_has_attendee_rate = !!_.get(booking, 'rate_details.attendee_pricing.upcharge', false);
  normalizeBookingObj.attendee_upcharge = _.get(booking, 'rate_details.attendee_pricing.upcharge', 0);
  normalizeBookingObj.hourly_rate = _.get(booking, 'rate', 0);
  normalizeBookingObj.base_rate = _.get(booking, 'listing.prices[0].value', 0);

  return normalizeBookingObj;
}

const productionQuestions = {
  lighting: [
    'has_natural_light',
    'can_block_out_light',
    'lighting_description'
  ],
  sound: [
    'has_soundproofing',
    'ambient_noise_description'
  ],
  access: [
    'space_access_types',
    'equipment_loading_description',
    'has_separate_crew_area',
    'separate_crew_area_description',
    'has_off_limit_areas',
    'off_limit_areas_description',
    'can_film_exterior'
  ],
  electrical: [
    'can_access_circuit_breaker',
    'electrical_system_description'
  ],
  rules: [
    'requires_production_insurance',
    'insurance_requirement_description',
    'can_move_furniture',
    'furniture_move_description',
    'can_use_smoke_machines',
    'nudity_allowed'
  ]
};

const hasItem = (keys, faqData) => {
  return (
    _.some(keys, (question) => {
      const answer = faqData[question];

      if (!_.has(faqData, question)) return false;
      if ('' === answer) return false;
      if (_.isNull(answer)) return false;
      if (_.isArray(answer) && 0 === answer.length) return false;

      return true;
    })
  );
};

analyticsIntegrations.normalizeListingObj = function (listing) {
  var pickedArray = [
    '_id',
    'activity',
    'category',
    'cleaning_fee_amount',
    'cleaning_fee_set',
    'currency_symbol',
    'date_created',
    'date_modified',
    'day_rate_discount_percent',
    'day_rate_discount_set',
    'has_add_ons',
    'has_price_by_day',
    'listing_favorite_count',
    'metro',
    'minimum_duration',
    'nonInteraction',
    'num_images',
    'num_of_amenities',
    'number_guests',
    'origin',
    'ownerId',
    'parentSpaceId',
    'price',
    'search_keyword',
    'sku',
    'sort_order',
    'sort_rank',
    'space_review_count',
    'space_review_stars',
    'use_type',
    'city',
    'state',
    'country'
  ];

  var normalizeListingObj = _.assign({}, _.pick(listing, pickedArray));
  const listingImage = _.get(listing, 'images[0].external_id', '');
  const listingUseType = _.get(listing, 'uses[0]', '');
  const priceObj = _.get(listing, 'prices[0]', {});
  const fnbApplies = _.get(listing, 'fandb_applies_to', null);
  const minAge = _.get(listing, 'min_age');
  const responsivenessObj = _.get(listing, 'host_responsiveness');

  normalizeListingObj.is_instant_book_active = !!listing.is_instant_book_active;
  normalizeListingObj.min_age = 0 === minAge ? 'All ages' : minAge;
  normalizeListingObj.fandb_listing = _.get(listing, 'fandb_required', false);
  normalizeListingObj.content_id = listing._id;
  if (fnbApplies) {
    normalizeListingObj.fandb_applies_to = fnbApplies;
  }
  if (listing.fandb_required && !_.isEmpty(priceObj)) {
    normalizeListingObj.fandb_base_rate = priceObj.base_value;
    normalizeListingObj.fandb_tax_pct = priceObj.tax_percent;
    normalizeListingObj.fandb_tip_pct = priceObj.gratuity_percent;
  }
  if (!_.isEmpty(responsivenessObj)) {
    normalizeListingObj.host_response_time = responsivenessObj.hours;
    normalizeListingObj.host_response_bucket = responsivenessObj.bucket;
    normalizeListingObj.host_response_status = responsivenessObj.level_label;
  }
  if (!_.has(listing.cleaning_fee_set)) {
    const hasCleaningFee = 'ACTIVATED' === _.get(listing, 'cleaning_fee.obj_state');
    normalizeListingObj.cleaning_fee_set = hasCleaningFee;
    normalizeListingObj.cleaning_fee_amount = hasCleaningFee ? listing.cleaning_fee.value : 0;
  }
  if (!_.has(listing.day_rate_discount_set)) {
    const hasDayRate = 'ACTIVATED' === _.get(listing, 'day_rate_discount.obj_state');
    normalizeListingObj.day_rate_discount_set = hasDayRate;
    normalizeListingObj.day_rate_discount_percent = hasDayRate ? listing.day_rate_discount.value : 0;
  }
  if (listingImage) { normalizeListingObj.cover_img_id = listingImage; }
  if (listing.id || listing._id) { normalizeListingObj.listing_id = listing.id ? listing.id : listing._id; }
  if (listing.page_title || listing.title) { normalizeListingObj.listing_title = listing.page_title ? listing.page_title : listing.title; }
  if (!_.has(listing.currency)) { normalizeListingObj.currency = _.get(listing, 'prices[0].currency'); }
  if (listing['price.currency']) { normalizeListingObj.currency = listing['price.currency']; }
  if (!listing.use_type && listingUseType) {
    normalizeListingObj.use_type = listingUseType;
  }
  normalizeListingObj.attendee_rate_tier_count = _.get(listing, 'attendee_pricing.tiers', []).length;

  // for the production segmentation P1 project
  const productionDetails = listing.production_details;
  let areProductionSectionsIncluded = {};
  if (productionDetails && 'Production' === normalizeListingObj.use_type) {
    areProductionSectionsIncluded = _.reduce(productionQuestions, (acc, sectionKeys, sectionName) => {
      acc['has_' + sectionName + '_info'] = hasItem(sectionKeys, productionDetails);
      return acc;
    }, {});
  }

  return {
    ...normalizeListingObj,
    ...areProductionSectionsIncluded,
    has_parking_info: !!listing.parking_info
  };
};

analyticsIntegrations.normalizeContractObj = function (contract, action, publicAddOns = []) {
  const masterContract = _.find(contract, { type: 'MASTER' }) || {};
  const spaceRentalContract = _.find(contract, { type: 'SPACE_RENTAL' }) || {};
  const pendingContract = 'HOST_UPDATE_SUBMITTED' === masterContract.state || 'OFFER_SUBMITTED' === masterContract.state || 'PENDING_GUEST_REQUEST_ACCEPT' === masterContract.state;
  const itemsArray = _.filter(contract, { type: 'ITEM' }, []);
  const hostId = masterContract.host_sso_id;
  const bookingObj = _.get(spaceRentalContract, 'meta.booking', {});
  const { calculations = {} } = masterContract;
  const booking_status = _.get(masterContract, 'state');
  //host and guest amounts
  const guestAmounts = _.get(calculations, 'guest', {});
  const hostAmounts = _.get(calculations, 'host', {});
  const guest_payment_amount = guestAmounts.payment || 0;
  const guest_payment_processing_fee = guestAmounts.fee || 0;
  const guest_payment_processing_fee_percent = guestAmounts.fee_percent || 0;
  const host_payout_amount = hostAmounts.payout || 0;
  const host_payout_processing_fee = hostAmounts.fee || 0;
  const host_payout_processing_fee_percent = hostAmounts.fee_percent || 0;
  const subtotal_amount = _.get(masterContract, `amounts.amount[${hostId}]`);
  // add-on amounts
  const host_add_ons_guest_processing_fee = _.get(calculations, 'tenant.breakouts.add_ons.guest.broker_fee', 0);
  const host_add_ons_host_processing_fee = _.get(calculations, 'tenant.breakouts.add_ons.host.broker_fee', 0);
  const host_add_ons_host_payout = _.get(calculations, 'tenant.breakouts.add_ons.host.payout', 0);
  const host_add_ons_base = _.get(calculations, 'add_ons.unit_cost', 0);
  const host_add_ons_taxes = _.get(calculations, 'add_ons.taxes', 0);
  const host_add_ons_fees = _.get(calculations, 'add_ons.fees', 0);
  const host_add_ons_subtotal = _.get(calculations, 'add_ons.amount', 0);
  // space rental amounts
  const space_rental_guest_processing_fee = _.get(calculations, 'tenant.breakouts.space_rentals.guest.broker_fee', 0);
  const space_rental_host_processing_fee = _.get(calculations, 'tenant.breakouts.space_rentals.host.broker_fee', 0);
  const space_rental_processing_fee = space_rental_guest_processing_fee + space_rental_host_processing_fee;
  const space_rental_host_payout =  _.get(calculations, 'tenant.breakouts.space_rentals.host.payout', 0);
  // cleaning fee
  const addtlCharges = _.get(bookingObj, 'addtl_charges', []);
  const cleaningFee = _.find(addtlCharges, function (charge) {
    return 'CLEANING_FEE' === charge.type;
  });
  const cleaning_fee_set = !!cleaningFee;
  const cleaning_fee_amount = _.get(cleaningFee, 'value');
  // day rate discount
  const  dayRateDiscount = _.find(bookingObj.discounts, function (discount) {
    return 'DAY_RATE_DISCOUNT' === discount.type;
  });
  const day_rate_set = !!dayRateDiscount;
  const day_rate_amount = _.get(dayRateDiscount, 'discount_amount');
  const day_rate_percent = _.get(dayRateDiscount, 'value');
  // variable pricing
  const bkg_has_price_by_day = _.get(bookingObj, 'rate_details.is_rate_variable', false);
  const bkg_has_attendee_rate = !!_.get(bookingObj, 'rate_details.attendee_pricing.upcharge', false);
  const attendee_upcharge = _.get(bookingObj, 'rate_details.attendee_pricing.upcharge', 0);
  const hourly_rate = _.get(bookingObj, 'rate', 0);
  // duration
  const day_count = _.get(bookingObj, 'daily_durations', []).length;
  // add-ons details
  var addOnsArray = []
  _.forEach(itemsArray, (item) => {
    const { meta, secondary_charges } = item;
    const taxesArray = _.filter(secondary_charges, { meta: { charge_type: 'tax' }}, []);
    const taxTotal = _.sum(_.map(taxesArray, function(tax) { return tax.amount; })).toFixed(2);
    const taxTotalPercent = _.sum(_.map(taxesArray, function(tax) { return _.get(tax, 'meta.amount', 0); })).toFixed(4);
    const feesArray = _.filter(secondary_charges, { meta: { charge_type: 'fee' }}, []);
    const feeTotal = _.sum(_.map(feesArray, function(fee) { return fee.amount; })).toFixed(2);
    const imageId = _.get(item, 'meta.image_ids[0]', '');
    const itemObj = {
      'item_id': item._id,
      'category': meta.category,
      'subcategory': meta.subcategory,
      'title': meta.label,
      'quantity': item.units,
      'price': item.custom_price ? item.custom_price : meta.unit_cost,
      'price_unit': meta.unit_cost_basis,
      'subtotal': item.primary_amount[hostId],
      'taxes_count': taxesArray.length,
      'taxes_percent': taxTotalPercent,
      'taxes_total': taxTotal,
      'host_fee_count': feesArray.length,
      'host_fee_total': feeTotal,
      'item_modified_date': item.modified,
      'custom_image': !!imageId,
      'image_id': imageId
    }
    addOnsArray.push(itemObj);
  });

  // visible add-on details
  const visible_add_ons = !!publicAddOns.length;
  var visibleAddOnsArray = []
  _.forEach(publicAddOns, (item, i) => {
    const imageId = _.get(item, 'image_ids[0]', '');
    const itemObj = {
      'item_id': item._id,
      'category': item.category,
      'subcategory': item.subcategory,
      'label': item.label,
      'unit_cost': item.unit_cost,
      'unit_cost_basis': item.unit_cost_basis,
      'max_quantity': item.count,
      'sort_order': i + 1,
      'custom_image': !!imageId,
      'image_id': imageId
    }
    visibleAddOnsArray.push(itemObj);
  });

  const {
    after_midnight,
    duration,
    guest_id,
    number_of_guests,
    _id: booking_id,
    is_instant_booking,
    base_rate
  } = bookingObj;

  const normalizeContractObj = {
    host_add_ons_base,
    host_add_ons_taxes,
    host_add_ons_fees,
    host_add_ons_subtotal,
    'host_add_ons_unique_items_count': itemsArray.length,
    'host_add_ons_total_items_count': _.sum(_.map(itemsArray, function(item) { return item.units; })),
    host_add_ons_guest_processing_fee,
    host_add_ons_host_processing_fee,
    'host_add_ons_processing_fee': (host_add_ons_guest_processing_fee + host_add_ons_host_processing_fee).toFixed(2),
    host_add_ons_host_payout,
    'host_add_ons_attached': addOnsArray,
    space_rental_guest_processing_fee,
    space_rental_host_processing_fee,
    space_rental_processing_fee,
    space_rental_host_payout,
    guest_payment_amount,
    guest_payment_processing_fee,
    guest_payment_processing_fee_percent,
    host_payout_amount,
    host_payout_processing_fee,
    host_payout_processing_fee_percent,
    subtotal_amount,
    after_midnight,
    duration,
    guest_id,
    number_of_guests,
    cleaning_fee_set,
    cleaning_fee_amount,
    day_rate_set,
    day_rate_amount,
    day_rate_percent,
    day_count,
    booking_id,
    booking_status,
    is_instant_booking,
    bkg_has_price_by_day,
    bkg_has_attendee_rate,
    attendee_upcharge,
    hourly_rate,
    base_rate,
    visible_add_ons,
    'host_add_ons_visible': visibleAddOnsArray,
    'value': guest_payment_amount
  }

  if ('accept' === action) {
    normalizeContractObj.host_add_ons_accepted = addOnsArray;
    delete normalizeContractObj.host_add_ons_attached;
  } else if ('decline' === action) {
    normalizeContractObj.host_add_ons_declined = addOnsArray;
    delete normalizeContractObj.host_add_ons_attached;
  } else if (pendingContract) {
    normalizeContractObj.host_add_ons_pending = addOnsArray;
    delete normalizeContractObj.host_add_ons_attached;
  }

  return normalizeContractObj;
};

// **** Custom Segment Function for Each Page **** //

//Collections Page
analyticsIntegrations.collectionThumbnailEventListener = function(){
  var collectionThumbnail = document.getElementsByClassName('featured-collections');
  for (var i = 0; i < collectionThumbnail.length; i++) {
    var collectionJSON = $(collectionThumbnail[i]).data("collection");
    collectionJSON = JSON.stringify(collectionJSON);
    if(collectionThumbnail[i]){
      analyticsIntegrations.itemClicked("collection selected", collectionThumbnail[i], "collection selected", collectionJSON, null, null);
    }
  }
};
// End of Collections Page

//Hero Section
analyticsIntegrations.heroSectionEventListener = function(){
  var browseButton = document.getElementById("browse-btn");
  var becomeHostButton = document.getElementById("become-host-btn");
  if (browseButton) {
    analyticsIntegrations.itemClicked("button click", browseButton, "hero image button");
  }
  if (becomeHostButton) {
    analyticsIntegrations.itemClicked("button click", becomeHostButton, "hero image button");
  }
};

analyticsIntegrations.searchEventListener = function(){
  var searchBtn = document.getElementById("searchbar-submit-button");
  if (searchBtn) {
    analyticsIntegrations.itemClicked("button click", searchBtn, "search");
  }
};

analyticsIntegrations.searchDropdown = function (category, label) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  analytics.track('dropdown clicked', {
    category: category,
    label: label + ' dropdown'
  });
};

//Learn More
analyticsIntegrations.learnMoreSectionEventListener = function(){
  var learnMoreBtn = document.getElementById("learn-more");
  if (learnMoreBtn) {
    analyticsIntegrations.itemClicked("button click", learnMoreBtn, "iOS link");
  }
};

//Banner Section
analyticsIntegrations.bannerSectionEventListener = function(){
  var bannerButton = document.getElementById("banner-btn");
  var buttonText = $(bannerButton).data("type");
  if (bannerButton) {
    analyticsIntegrations.itemClicked("button click", bannerButton, buttonText);
  }
};

//Event Planning Section
analyticsIntegrations.eventPlanningSectionEventListener = function(){
  var eventPlanning = document.getElementById("event-planning-btn");
  if (eventPlanning) {
    analyticsIntegrations.itemClicked("button click", eventPlanning, 'Event planning link');
  }
};

//Join Us Section
analyticsIntegrations.joinUsEventListener = function(){
  var joinUsBtn = document.getElementById("join-us-btn");
  if (joinUsBtn) {
    analyticsIntegrations.itemClicked("button click", joinUsBtn, 'join link');
  }
};


//Download Page
analyticsIntegrations.joinUsEventListener = function(){
  var downloadBtn = document.getElementById("download-btn");
  if (downloadBtn) {
    analyticsIntegrations.itemClicked("button click", downloadBtn, 'iOS link');
  }
};
//Use-Type Page
analyticsIntegrations.conciergeSectionListener = function () {
  var conciergeButton = document.getElementById("concierge-button");
  if (conciergeButton) {
    analyticsIntegrations.itemClicked("button click", conciergeButton ,"Find Me A Space");
  }
};

analyticsIntegrations.trackEvent = function(event, properties, options, callback) {
  if (!analyticsIntegrations.segmentLoaded()) {return;}
  analytics.track(event, properties, options, callback);
};
// End of Use-Type Page;

//Listings Page
analyticsIntegrations.listingsProductView = function (listingObject, originAction) {
  if (!analyticsIntegrations.segmentLoaded() || !listingObject) {return;}
  var useType, metro, neighborhood, category, origin, slashCount;
  var properties = {};
  if (originAction) {
    origin = originAction;
  } else if (-1 !== document.referrer.indexOf('/s/')) {
    origin = 'search';
  } else if (-1 !== document.referrer.indexOf('/u/')) {
    origin = 'use type';
  } else if (-1 !== document.referrer.indexOf('/venues/')) {
    slashCount = document.referrer.split('/').length;
    origin = 5 < slashCount ? 'keyword' : 'city';
  } else if (-1 !== document.referrer.indexOf('/featured/')) {
    origin = 'collection';
  } else {
    origin = document.referrer;
  }

  priceObj = listingObject.prices;
  useType = listingObject.use_type;
  metro = listingObject.metro || "unknown";
  neighborhood = listingObject.neighborhood || "unknown";
  category = useType + "/" + metro + "/" + neighborhood;
  const searchKW = PSSessions.Cookies('PSSK');
  properties = analyticsIntegrations.normalizeListingObj(listingObject);
  properties.search_keyword = searchKW;
  properties.search_keyword_type = PSSessions.Cookies('PSSKT');
  // this is in the head tag of listing page
  properties.sort_rank = sortRank;
  properties.sku = listingObject._id;
  properties.origin = origin;
  properties.category = category;
  properties.price = listingObject.price;
  properties.nonInteraction = 1;
  properties.search_id = PSSessions.Cookies('search_id');
  properties.listing_viewed_id = window.listing_viewed_id;
  analytics.track("Viewed Product", properties, {
    Quantcast: {
      labels: [ searchKW, useType ]
    }
  });
};

analyticsIntegrations.shareModalView = function (listingObject, origin) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }

  var properties = analyticsIntegrations.normalizeListingObj(listingObject);

  const useType = listingObject.use_type;
  const metro = listingObject.metro || "unknown";
  const neighborhood = listingObject.neighborhood || "unknown";
  const category = useType + "/" + metro + "/" + neighborhood;

  properties.origin = origin;
  properties.category = category;

  analytics.track("share modal viewed", properties);
};

analyticsIntegrations.shareBtnClick = function (listingObject, origin, whichShareBtn) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }

  var properties = analyticsIntegrations.normalizeListingObj(listingObject);

  const useType = listingObject.use_type;
  const metro = listingObject.metro || "unknown";
  const neighborhood = listingObject.neighborhood || "unknown";
  const category = useType + "/" + metro + "/" + neighborhood;

  properties.origin = origin;
  properties.label = whichShareBtn;
  properties.category = category;

  analytics.track("share button clicked", properties);
};


analyticsIntegrations.referralLinkCopied = function (ssoId) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }

  analytics.track("referral link copied", { ssoId });
};

analyticsIntegrations.searchByDate = function (origin, startDate, endDate, duration, isFirstTime) {
  analytics.track("booking dates submitted", {
    origin,
    start_date: startDate,
    end_date: endDate,
    duration_in_hours: duration,
    is_first_time_update: isFirstTime
  });
}

analyticsIntegrations.pageUrl = function pageUrl() {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  return location.pathname;
};

/* These Functions are currently in their respective components.
 Why, you may ask? Because requiring them wonks it all.
 */

analyticsIntegrations.availabilityBlock = function(originalTimesRequested, listing, conflictReason) {
  // if no conflict, function shouldn't be called
  if (!analyticsIntegrations.segmentLoaded()) { return; }

  var properties = originalTimesRequested;
  var category = listing.use_type + "/" + listing.metro;

  properties.category = category;
  properties.reason_blocked = conflictReason; // add the reason for the conflict here
  analytics.track("availability blocked", properties);
};

analyticsIntegrations.messageTrack = function (str, listingObj, bookingObj, eventProps, publicAddOns, origin) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var properties = {};
  var pageName = analyticsIntegrations.pageUrl();
  properties.search_keyword = PSSessions.Cookies('PSSK');
  properties.search_keyword_type = PSSessions.Cookies('PSSKT');
  properties["page name"] = pageName;
  properties.category = listingObj.use_type + "/" + listingObj.metro;
  properties.label = pageName;
  properties.origin = origin;
  if (listingObj.update_organization || listingObj.update_profession) {
    var sentUsrObj = {};
    if (listingObj.update_organization) {
      sentUsrObj.organization = eventProps.organization;
    }
    if (listingObj.update_profession) {
      sentUsrObj.title = eventProps.profession;
    }
    sentUsrObj.ssoId = eventProps.ssoId;
    analytics.identify(eventProps.ssoId, sentUsrObj);
  }

  var normalListing = {};
  var normalBooking = {};
  if (!_.isEmpty(listingObj)) {
    normalListing = analyticsIntegrations.normalizeListingObj(listingObj);
  }
  if (!_.isEmpty(bookingObj)) {
    normalBooking = analyticsIntegrations.normalizeContractObj(bookingObj, '', publicAddOns);
  }

  normalListing.content_ids = normalListing.content_id;
  delete normalListing.content_id;

  var payload = _.assign({}, properties, normalListing, normalBooking, eventProps);

  // duplicates and confusing. We should use listing_id or booking_id
  delete payload.id;
  delete payload._id;

  // remove PII
  delete payload.profession;
  delete payload.organization;

  analytics.track(str, payload);
};

analyticsIntegrations.transactableViewed = function transactableViewed(missingArray) {
  if (!analyticsIntegrations.segmentLoaded() || !listingJSON) { return; }
  var properties = {"blockers": missingArray};
  properties.category = "Account";
  properties.label = missingArray;
  properties["page name"] = analyticsIntegrations.pageUrl();
  analytics.track("transactable blocker viewed", properties);
};

analyticsIntegrations.favorited = function favorited(added, listingObj, origin) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var properties = listingObj;
  if (!added) {
    properties.status = "removed";
  } else {
    properties.status = "added";
  }
  properties.label = properties.status;
  properties.origin = origin;
  properties.category = properties.use_type + "/" + properties.metro;
  analytics.track("favorited", properties);
};

analyticsIntegrations.normalizeBoardObj = function normalizeBoardObj (project, checkTastemaker) {
  var date = _.get(project.schedule, ['0', 'start', 'date'], {});
  var formattedDate = date.m ? moment(date.m + '-' + date.d + '-' + date.y, 'MM-DD-YYYY') : moment(date).format('YYYY-MM-DD');
  var boardParams = {
    board_id: project._id,
    board_activity: project.activity,
    board_date: formattedDate,
    board_location: project.location,
    board_name: project.name,
    total_listing_count: project.count,
    board_external_id: project.external_id
  };
  if (checkTastemaker) {
    var isTastemaker = !!project.tastemaker;
    analyticsIntegrations.mergeObject(boardParams, { is_tastemaker: isTastemaker });
  }
  return boardParams;
};

analyticsIntegrations.votingCommenting = function votingCommenting (actionType, userAction, listing, project, boardListingObj, optionalObj, profile) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }

  var properties = {};
  properties.label = userAction;
  properties.action = userAction;
  properties.path = location.pathname;
  var normalizedListing = listing && !_.isEmpty(listing) ? analyticsIntegrations.normalizeListingObj(listing) : {};
  var normalizedProject = analyticsIntegrations.normalizeBoardObj(project);
  var mergeObject = _.assign({}, properties, boardListingObj, normalizedListing, normalizedProject);
  if (optionalObj) {
    mergeObject = analyticsIntegrations.mergeObject(mergeObject, optionalObj);
  }
  if ('account created' === actionType && profile) {
    var ssoId = profile.SSOid;
    var profileData = {};
    profileData.id = ssoId;
    profileData.email = profile.username;
    profileData.createdAt = profile.date_created;
    profileData.is_logged_in = true;
    mergeObject.context = {
      traits: profileData
    };
    analytics.alias(ssoId);
    analytics.identify(ssoId, profileData);
  }
  analytics.track(actionType, mergeObject);
};

analyticsIntegrations.boardHasBeenCopied = function copyBoardAnalytic (project, sourceBoardPath, copiedBoardPath) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var normalizedProject = analyticsIntegrations.normalizeBoardObj(project, true);
  var properties = {
    action: 'copy_board',
    label: 'copy_board',
    source_path: sourceBoardPath,
    copied_path: copiedBoardPath
  };
  analytics.track("board copied", analyticsIntegrations.mergeObject(normalizedProject, properties));
};

analyticsIntegrations.genericBoardAction = function genericBoardAction (actionType, project, optionalObj) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var normalizedProject = analyticsIntegrations.normalizeBoardObj(project);
  var mergeObject = analyticsIntegrations.mergeObject(normalizedProject, optionalObj);

  analytics.track(actionType, analyticsIntegrations.mergeObject(mergeObject, {
    action: actionType,
    source: actionType,
    label: actionType,
    path: location.pathname
  }));
};

analyticsIntegrations.createBoardViewed = function createBoardViewed (isFirstTime, listing, origin, activity, useType, listingImgID) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }

  var properties = analyticsIntegrations.normalizeListingObj(listing);

  properties.is_first_time = isFirstTime;
  properties.origin = origin;
  properties.label = origin;
  properties.activity = activity;

  properties.category = useType + "/" + properties.metro;
  analytics.track("board form viewed", properties);
};

analyticsIntegrations.boardCreated = function boardCreated (isFirstTime, listing, origin, activity, useType, listingImgID, project) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var listing = analyticsIntegrations.normalizeListingObj(listing);
  var normalizedProject = analyticsIntegrations.normalizeBoardObj(project);

  var properties = { };
  properties.is_first_time = isFirstTime;
  properties.origin = origin;
  properties.label = origin;
  properties.activity = activity;

  properties.category = useType + "/" + properties.metro;
  properties.board_event_date = project.created;
  var fullPayload = _.merge(properties, listing, normalizedProject);

  analytics.track("board created (frontend)", fullPayload);
};

analyticsIntegrations.listBoardViewed = function listBoardViewed (isFirstTime, listing, origin, activity, useType, listingImgID, boardsCount) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }

  var properties = analyticsIntegrations.normalizeListingObj(listing);

  properties.is_first_time = isFirstTime;
  properties.origin = origin;
  properties.label = origin;
  properties.activity = activity;

  properties.category = useType + "/" + properties.metro;

  properties.boards_viewed = boardsCount;

  analytics.track("board list viewed", properties);
};

analyticsIntegrations.boardJoinViewed = function boardJoinViewed (board_id) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  analytics.track("join_modal_viewed", { board_id: board_id });
};

analyticsIntegrations.boardJoinClicked = function boardJoinClicked (board_id) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  analytics.track("join_modal_clicked", { board_id: board_id });
};

analyticsIntegrations.boardJoined = function boardJoined (properties) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  analytics.track("board_joined", properties);
};

analyticsIntegrations.duplicateName = function duplicateName (boardName) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  analytics.track("duplicate board error", boardName);
};

analyticsIntegrations.fetchedBoards = function fetchedBoards (boards) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  analytics.track("user boards fetched", { boards: boards });
};

analyticsIntegrations.boardListingsSaved = function boardListingsSaved (listing, origin, activity, useType, listingImgID, isCreate, boardIds, analyticName) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }

  var properties = analyticsIntegrations.normalizeListingObj(listing);
  properties.origin = origin;
  properties.label = origin;
  properties.activity = activity;
  properties.listing_img_id = listingImgID;
  properties.use_type = useType;
  properties.category = useType + "/" + properties.metro;

  properties.on_board_created = isCreate;
  properties.boards_selected = boardIds.length;
  properties.board_ids = boardIds;

  analytics.track(analyticName || "listing saved (frontend)", properties);
};

analyticsIntegrations.shareBoardViewed = function shareBoardViewed (project, origin, activity, emailOrigin) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  const properties = {};
  properties.origin = origin;
  properties.label = origin;
  properties.activity = activity;
  properties.email_origin = emailOrigin;

  properties.board_id = project._id;
  properties.board_obj = project;
  analytics.track("board invite form viewed", properties);
};

analyticsIntegrations.shareInviteSent = function shareInviteSent (project, origin, activity, inviteCount, isDefaultMsg, emailOrigin) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  const properties = {};
  properties.origin = origin;
  properties.label = origin;
  properties.email_origin = emailOrigin;
  properties.activity = activity;
  properties.email_count = inviteCount;
  properties.is_default_message = isDefaultMsg;
  properties.board_id = project._id;
  properties.board_obj = project;
  analytics.track("board Invite Sent (frontend)", properties);
};

analyticsIntegrations.bookingPriceCreated = function(feeObj, contracts){
  if (!analyticsIntegrations.segmentLoaded() || !listingJSON) {return;}
  var pageName = analyticsIntegrations.pageUrl();
  var properties = feeObj;
  var category = listingJSON.use_type +"/"+listingJSON.metro;
  properties.category = category;
  properties.label = pageName;
  properties.search_keyword = PSSessions.Cookies('PSSK');
  properties.search_keyword_type = PSSessions.Cookies('PSSKT');
  properties.listing_viewed_id = window.listing_viewed_id;
  // use new booking obj
  const mergedProperties = {
    ...analyticsIntegrations.normalizeContractObj(contracts),
    ...properties
  }
  analytics.track("booking price created", mergedProperties);
};

analyticsIntegrations.startBooking = function(parsedUrl, origin, additionalProps = {}) {
  if (!analyticsIntegrations.segmentLoaded() || !listingJSON) { return; }
  var properties = listingJSON;
  properties.category = properties.page_title + "/" + properties.metro;
  properties.sort_rank = parsedUrl.sort_order;
  properties.origin = origin;
  properties.listing_viewed_id = window.listing_viewed_id;
  analytics.track("start booking", Object.assign({}, properties, additionalProps));
};

analyticsIntegrations.carouselOpened = function carouselOpened (booking) {
  if (!analyticsIntegrations.segmentLoaded() || !listingJSON) { return; }
  var properties = analyticsIntegrations.normalizeListingObj(listingJSON);
  if (booking) {
    properties.booking_id = booking._id;
    properties.invite_id = booking.pid;
    properties.listing_id = booking.listing_id;
  }
  analytics.track("carousel opened", properties);
};

analyticsIntegrations.similarListingsSectionViewed = function similarListingsSectionViewed (e, listing, source) {
  var listingID = _.get(listing, '_id');
  var useType = _.get(listing, 'use_type');
  var metro = _.get(listing, 'metro');
  var neighborhood = _.get(listing, 'neighborhood');
  var category = [useType, metro, neighborhood].join('/');
  var recommendedListings = _.get(listing, 'recommendedListings');
  var properties = _.chain(recommendedListings).map(function parseSimiliarListings (l, i) {
    var rank = i + 1;
    var listingId = l.id || '';
    var price = l.price_hourly || '';
    var keys = ['sim_list_' + rank + '_id', 'sim_list_' + rank + '_price', 'sim_list_' + rank + '_rank'];
    var values = [listingId, price, rank];
    var simList = {};
    _.forEach(keys, function mapVals (key, i) {
      simList[key] = values[i];
    });
    return simList;
  }).reduce( function reduceParsedListings (total, sl) {
    return _.merge(total, sl);
  }, {})
  .merge({ listingID: listingID, category: category, source: source, label: source, listing_viewed_id: window.listing_viewed_id }).value();
  analytics.track('Similar Listings Viewed', properties);
};
// End of Listing Page

//Public: shared segment code
analyticsIntegrations.itemClicked = function(itemTitle, element, elementName, sharedObject, clickTarget, clickArea){
  // if (!analyticsIntegrations.segmentLoaded() || !sharedObject) {return;}
  if (!analyticsIntegrations.segmentLoaded()) {return;}
  var properties = {}, category, pageName, categoryName, elementClicked, elementSelected, parsedSharedObj;
  var sessions = PSSessions.Cookies('PSAccess');
  elementSelected = elementName;
  if(sharedObject){
    parsedSharedObj = JSON.parse(sharedObject);
    properties = parsedSharedObj;
  } else {
    parsedSharedObj = {};
  }
  if('undefined' !== typeof websiteJSON){
    if('index' === websiteJSON.page){
      pageName = 'home';
      categoryName = "home";
    } else {
      pageName = websiteJSON.page;
      categoryName = websiteJSON.page;
    }
  }
  if('undefined' !== typeof useTypeJSON){
    pageName = "use type landing page";
    categoryName = "use type landing page";
    properties.use =  useTypeJSON.use_type;
    properties.metro = useTypeJSON.metro;
  }
  if('undefined' !== typeof listingJSON){
    var use, metro; //for listings
    use = parsedSharedObj.use;
    use = properties.use;
    metro = parsedSharedObj.metro;
    pageName = "SEO listing";
    categoryName = use +"/"+ metro;
  }
  if('undefined' !== typeof collectionsJSON){
    properties = parsedSharedObj;
    pageName = "featured collections";
    categoryName = "featured collections";
  }
  if('undefined' !== typeof profileJSON){
    properties = parsedSharedObj;
    pageName = "profile";
    categoryName = "profiles";
  }

  properties["page name"] = pageName;
  properties.selection = elementSelected;
  properties["click target"] = clickTarget;
  properties.label = elementSelected;
  properties.area = clickArea;
  properties.category = categoryName;
  analytics.trackLink(element, itemTitle, properties);
};


// Share Event Listner
analyticsIntegrations.addShareEventListeners = function() {
  var pinterestButton, fbButton, emailButton, twitterButton, sharedJSON;
  pinterestButton = document.getElementById('pinterest');
  fbButton = document.getElementById('fb');
  twitterButton = document.getElementById('twitter');
  emailButton = document.getElementById('email');

  // Checks for Global JSON object
  if('undefined' != typeof collectionsJSON){
    sharedJSON = collectionsJSON;
  }
  if('undefined' != typeof listingJSON){
    sharedJSON = listingJSON;
  }
  if('undefined' != typeof profileJSON){
    sharedJSON = profileJSON;
  }
  sharedJSON = JSON.stringify(sharedJSON);
  // Adds Event listeners to share buttons
  if (pinterestButton) {
    analyticsIntegrations.itemClicked("share button clicked", pinterestButton, "pinterest", sharedJSON);
  }
  if (fbButton) {
    analyticsIntegrations.itemClicked("share button clicked", fbButton, "facebook", sharedJSON);
  }
  if (emailButton) {
    analyticsIntegrations.itemClicked("share button clicked", emailButton, "email", sharedJSON);
  }
  if (twitterButton) {
    analyticsIntegrations.itemClicked("share button clicked", twitterButton, "twitter", sharedJSON);
  }
};

analyticsIntegrations.addListingBlockEventListeners = function(){
  var listingAnalytics =  document.getElementsByClassName('listing-analytics');
  var listingImg = document.getElementsByClassName('listing-img');
  var listingTitle = document.getElementsByClassName('listing-title');
  var listingLink = document.getElementsByClassName('listing-link');

  for (var i = 0; i < listingAnalytics.length; i++) {
    var listingJSON = $(listingAnalytics[i]).data("listing");
    listingJSON = JSON.stringify(listingJSON);
    if(listingImg[i]){
      analyticsIntegrations.itemClicked("listing selected", listingImg[i], null, listingJSON, "thumbnail");
    }
    if(listingTitle[i]){
      analyticsIntegrations.itemClicked("listing selected", listingTitle[i], null, listingJSON, "title");
    }
    if(listingLink[i]){
      analyticsIntegrations.itemClicked("listing selected", listingLink[i], null, listingJSON, "description link");
    }
  }
};

analyticsIntegrations.addNavFooterListeners = function() {
  var destination, addFooterListener, addHeaderListener,
      elementsForLinkTrack;

  // these are the basic destination names that have links
  // throughout the site
  elementsForLinkTrack = [
    "about",
    "careers",
    "guest",
    "host",
    "blog",
    "support",
    "terms",
    "privacy",
    "signin",
    "signup",
    "home",
    "mobile",
    "download",
    "add_space",
    "search",
    "facebook",
    "twitter",
    "googleplus",
    "linkedin",
    "pinterest",
    "referrals"
  ];

  // adds footer link listeners
  addFooterListener = function(dest) {
    var elementName, element;
    elementName = "footer_link_" + dest;
    element = document.getElementById(elementName);
    if (element) {analyticsIntegrations.itemClicked("nav clicked", element, dest, null, null, elementName);}
  };

  // adds header bar link listeners
  addHeaderListener = function(dest) {
    var elementName, element;
    elementName = "header_link_" + dest;
    element = document.getElementById(elementName);
    if (element) {analyticsIntegrations.itemClicked("nav clicked", element, dest, null, null, elementName);}
  };

  for (var i=0; i < elementsForLinkTrack.length; i++) {
    destination = elementsForLinkTrack[i];
    addHeaderListener(destination);
    addFooterListener(destination);
  }
};

//Referral Page
analyticsIntegrations.trackReferralClick = function (source) {
  if (!analyticsIntegrations.segmentLoaded()) {return;}
  var properties = {
    button: 'referral',
    source: source,
    destination: 'referrals'
  };
  analytics.track('referral clicked', properties);
}

// Search Page
analyticsIntegrations.searchProductViewPayload = function (searchObj, mapAction, listings, action, optionalObj = {}) {
  if (!analyticsIntegrations.segmentLoaded() || !searchObj) {return;}
  var useType = searchObj.space_use;
  var searchKey = searchObj.a;
  var searchType;
  var origin;
  var slashCount;
  var label = location.pathname + location.search;
  if (searchObj.point_of_interest) {
    searchType = 'POI';
  } else if (searchObj.bbox_of_interest) {
    searchType = 'Region';
  } else {
    searchType = 'Metro';
  }

  if (('PUSH' === action)) {
    origin = 'search';
  } else if (document.referrer === (location.origin + '/')) {
    origin = 'home';
  } else if (-1 !== document.referrer.indexOf('/u/')) {
    origin = 'use type';
  } else if (-1 !== document.referrer.indexOf('/venues/')) {
    slashCount = document.referrer.split('/').length;
    origin = 5 < slashCount ? 'keyword' : 'city';
  } else if (-1 !== document.referrer.indexOf('/featured/')) {
    origin = 'collection';
  } else {
    origin = document.referrer;
  }

  const searchKW = PSSessions.Cookies('PSSK');
  const amenitiesString = _.get(searchObj, 'features', '');
  const amenitiesArray = amenitiesString ? amenitiesString.split(',') : [];
  const spaceTypeString = _.get(searchObj, 'space_type', '');
  const spaceTypeArray = spaceTypeString ? spaceTypeString.split(',') : [];
  const minGuestCount = _.chain(searchObj).get('min_guest').toNumber().value();
  const minHourlyPrice = _.chain(searchObj).get('price_hourly_min').toNumber().value();
  const address = searchObj.address_bbox ? searchObj.address_bbox.replace(/\%20/g, ' ').replace(/\%2C/g, ',') : 'undefined';
  const metro = searchObj.loc_code;
  var properties = {};
  properties.category = useType;
  properties.label = metro || address;
  properties.location = metro ? _.startCase(metro.replace(/--/g, ', ').replace(/-/g, ' ')) : '' || _.startCase(address);
  properties.search_key = searchKey;
  properties.search_keyword = searchKW;
  properties.search_keyword_type = PSSessions.Cookies('PSSKT');
  properties.min_guest = searchObj.min_guest;
  properties.max_guest = searchObj.max_guest;
  properties.price_min = searchObj.price_hourly_min;
  properties.price_max = searchObj.price_hourly_max;
  properties.is_instant_book_active_filter = searchObj.is_instant_book_active;
  properties.fandb_filter_shown = optionalObj.filterFnbShown;
  properties.fandb_filter_applied = searchObj.fandb_required;
  properties.zoom = searchObj.zoom;
  properties.origin = origin;
  properties.url = location.href;
  properties.search_type = searchType;
  properties.viewport_bbox = searchObj.viewport_bbox;
  properties.lat = searchObj.point_of_interest ? JSON.parse(searchObj.point_of_interest)[0] : undefined;
  properties.long = searchObj.point_of_interest ? JSON.parse(searchObj.point_of_interest)[1] : undefined;
  properties.listing_count = listings;
  properties.map_search = mapAction || false;
  properties.nonInteraction = 1;
  properties.number_of_space_type_filters_applied = spaceTypeArray.length;
  properties.space_type_filter_options_used = spaceTypeArray;
  properties.number_of_amenities_filters_applied = amenitiesArray.length;
  properties.amenities_filter_options_used = amenitiesArray;
  properties.custom_attendee_filter = optionalObj.customAttendeeFilter;
  properties.custom_price_filter = optionalObj.customPriceFilter;
  properties.search_has_date = optionalObj.searchHasDate;
  properties.start_date = optionalObj.startDate;
  properties.end_date = optionalObj.endDate;
  properties.duration_in_hours = optionalObj.durationInHours;
  properties.search_id = optionalObj.searchId;
  properties.page = searchObj.p || 1;
  properties.experiments = window && window.searchExperimentId ? window.searchExperimentId : '';
  return properties;
};

analyticsIntegrations.showMinHoursWarning = function (show) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  analytics.track('display min hours warning', { show });
};

analyticsIntegrations.viewedSearchResults = function (listings, searchObj, mapAction, listingCount, action, optionalObj) {
  if (!analyticsIntegrations.segmentLoaded()) {return;}
  const analyticsPayload = analyticsIntegrations.searchProductViewPayload(searchObj, mapAction, listingCount, action, optionalObj)
  const results = _.reduce(listings, function (result, val) {
    const t = result || {};
    const hostResponseTime = _.get(val, 'host_responsiveness.hours', '');
    const displayedResponseTime = _.get(val, 'host_responsiveness.bucket', '');
    const coverImg = _.get(val, 'images.0.external_id', '');
    t.title = [...t.title || [], val.title];
    t.thumbnail_listing_id = [...t.thumbnail_listing_id || [], val._id || val.id];
    t.thumbnail_attendees = [...t.thumbnail_attendees || [], val.number_guests];
    t.thumbnail_rating = [...t.thumbnail_rating || [], val.space_review_stars];
    t.thumbnail_price = [...t.thumbnail_price || [] , val['price.hourly']];
    t.thumbnail_response_time = [...t.thumbnail_response_time || [], hostResponseTime];
    t.thumbnail_cover_img = [...t.thumbnail_cover_img || [], coverImg];
    t.thumbnail_displayed_response_time = [...t.thumbnail_displayed_response_time || [], displayedResponseTime];
    t.thumbnail_isFNB = [...t.thumbnail_isFNB || [], val.fandb_required || false];
    t.thumbnail_is_instant_bookable = [...t.thumbnail_is_instant_bookable || [], val.is_instant_book_active || false];
    t.thumbnail_review_count = [...t.thumbnail_review_count || [], val.space_review_count]
    return t;
  }, {});
  analytics.track('Viewed Search Results', _.assign({}, results, analyticsPayload));
};

analyticsIntegrations.searchProductView = function (searchObj, mapAction, listings, action, optionalObj) {
  if (!analyticsIntegrations.segmentLoaded() || !searchObj) {return;}

  var properties = analyticsIntegrations.searchProductViewPayload(searchObj, mapAction, listings, action, optionalObj);
  var useType = searchObj.space_use;
  const searchKW = PSSessions.Cookies('PSSK');

  analytics.track("Viewed Product Category", properties, {
    Quantcast: {
      labels: [ searchKW, useType ]
    }
  });
};

analyticsIntegrations.specialEventsAd = function (event, filterObj) {
  if (!analyticsIntegrations.segmentLoaded()) {
    return;
  }
  const properties = {
    searchId: PSSessions.Cookies('search_id'),
    search_keyword: PSSessions.Cookies('PSSK') || 'none',
    location: filterObj.locationObj,
    min_guest: filterObj.min_guest,
    max_guest: filterObj.max_guest,
    price_min: filterObj.price_hourly_min,
    price_max: filterObj.price_hourly_max,
    search_has_date: !!filterObj.availability_interval
  }
  analytics.track(event, properties);
};

analyticsIntegrations.locationModal = function (location) {
  if (!analyticsIntegrations.segmentLoaded()) {return;}
  var properties = {};
  var origin = location;
  if ('modal' === origin ) {
    origin = location.href;
  }
  properties.origin = origin;
  analytics.track("search: see all locations", properties);
};

analyticsIntegrations.searchEmail = function (results, queryObj, location) {
  if (!analyticsIntegrations.segmentLoaded() || !results) {return;}
  var searchType;
  var origin = location;
  var results = results[0];

  if ('modal' === origin ) {
    origin = location.href;
  }

  if ('APPROXIMATE' === results.geometry.location_type) {
    searchType = 'Region';
  } else {
    searchType = 'POI';
  }

  var properties = {};
  properties.category = queryObj.space_use;
  properties.label = results.formatted_address;
  properties.origin = origin;
  properties.search_type = searchType;
  properties.lat = results.geometry.location.lat();
  properties.long = results.geometry.location.lng();
  properties.nonInteraction = 1;
  analytics.track('search: location not live', properties);
};

analyticsIntegrations.searchError = function (inputValue, location, paramNotFound) {
  if (!analyticsIntegrations.segmentLoaded() || !inputValue) {return;}
  var properties = {};
  var origin = location;
  if ('modal' === origin) {
    origin = location.href;
  }
  properties.label = inputValue;
  properties.origin = origin;
  properties.nonInteraction = 1;
  analytics.track('search: ' + paramNotFound + ' not found', properties);
};

analyticsIntegrations.guidedSearch = function guidedSearchAnalytics (eventName, params) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }

  const defaultParams = {
    version: 'V2'
  };

  const properties = Object.assign({}, defaultParams, params);
  analytics.track(eventName, properties);

};

// Sign up viewed, account created, signup profile form viewed, signup profile form submitted
analyticsIntegrations.signupForm = function signupFormAnalytic (signupAction, extraAttrs, profile) {
  /* extraAttrs: source, method */
  var actionSource;
  var urlSource = extraAttrs.source;

  if (!analyticsIntegrations.segmentLoaded()) { return; }
  function getAction () {
    // sets actionSource also;
    var action;
    switch (urlSource) {
      case 'fav' :
        action = 'save';
        actionSource = 'details';
        break;
      case 'favc' :
        action = 'save';
        actionSource = 'carousel';
        break;
      case 'favb' :
        action = 'save';
        actionSource = 'bottom_bar';
        break;
      case 'favt' :
        action = 'save';
        actionSource = 'thumbnail';
        break;
      case 'favm' :
        action = 'save';
        actionSource = 'map thumbnail';
        break;
      case 'fee' :
        action = 'start_bkg';
        actionSource = 'details';
        break;
      case 'feec' :
        action = 'start_bkg';
        actionSource = 'carousel';
        break;
      case 'msg' :
        action = 'msg_host';
        actionSource = 'details';
        break;
      case 'host' :
        action = 'list_space';
        actionSource = 'hero';
        break;
      case 'hostf' :
        action = 'list_space';
        actionSource = 'footer';
        break;
      case 'log' :
        action = 'log_in';
        break;
      case 'nav' :
        action = 'sign_up';
        break;
      case 'guest referral' :
        action = 'guest';
        actionSource = '';
        break;
      default:
        action = 'none';
        actionSource = 'none';
    }
    return action;
  }
  var action = getAction();

  var getPageType = function getPageType () {
    var splitPath = _.words(location.pathname);
    var parsedPath = !splitPath[0] ? 'home' : ( 'pages' === splitPath[0]) ? splitPath[1] : splitPath[0];
    var pageType;
    switch (parsedPath) {
      case 's':
        pageType = 'search';
        break;
      case 'u':
        pageType = 'use type';
        break;
      case 'featured':
        pageType = 'collections';
        break;
      case 'plan':
        pageType = 'activity';
        break;
      case 'venues':
        pageType = 'keyword';
        break;
      case 'listings':
        pageType = 'listing';
        break;
      case 'referrals':
        pageType = 'referral';
        break;
      default:
        pageType = parsedPath;  /* home, host, signin, bkc, etc. */
    }
    return pageType;
  };

  var page_type = getPageType();
  var use_type = PSSessions.Cookies('PSUT') || 'none';
  var metro = PSSessions.Cookies('PSmetro') || 'none';
  var activity = PSSessions.Cookies('PSSK') || 'none';
  var path = location.pathname;
  var app = 'web';
  var category = [metro, use_type, activity].join('/');

  var isLoginOrSignup = 'sign_up' === action || 'log_in' === action;
  var isAccountCreated = 'account created' === signupAction;
  var source = _.without([action , (isLoginOrSignup ? 'nav' : page_type), actionSource], undefined).join(' ').trim();
  var email_opt_out = _.get(profile, 'email_unsubscribes.all', false);

  var attrs = {
    page_type: page_type,
    metro: metro,
    activity: activity,
    path: path,
    app: app,
    source: source,
    label: source,
    category: category,
    use_type: use_type,
    action: action,
    ...(isAccountCreated && { email_opt_out: email_opt_out })
  };

  if (PSSessions.Cookies('host-ref-promo')) {
    attrs.referral_code = PSSessions.Cookies('host-ref-promo');
    attrs.referral_type = 'host_referral';
    attrs.referral_user = PSSessions.Cookies('host-ref-promo-user-id');
  }

  var attrsToSubmit = extraAttrs.method ? _.merge(attrs, { method: extraAttrs.method }) : attrs;

  const actions = ['account created', 'signup profile form submitted']
  if (_.isEmpty(profile) || !_.includes(actions, signupAction)) {
    return analytics.track(signupAction, attrsToSubmit);
  }

  var ssoId = profile.SSOid;
  var identifyProps = {
    id: ssoId,
    email: profile.username,
    createdAt: profile.date_created,
    is_logged_in: true
  };

  if ('account created' === signupAction) {
    attrsToSubmit.context = {
      traits: identifyProps
    };
    analytics.alias(ssoId);
    analytics.identify(ssoId, identifyProps);
    analytics.track("account created", attrsToSubmit);
  } else if ('signup profile form submitted' === signupAction) {
    const properties = {
      heard_about_us: profile.heard_about_us,
      user_id: profile._id,
      timestamp: Date.now()
    };

    analytics.identify(ssoId, { ...identifyProps, heard_about_us: profile.heard_about_us });
    analytics.track("signup profile form submitted", {...properties, ...attrsToSubmit});
  }
};

// Log In / Log Out
analyticsIntegrations.accountLogin = function(ssoId){
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var properties = {};
  properties.ssoID = ssoId;
  properties.category = "Account";
  properties.is_logged_in = true;
  analytics.identify(ssoId, properties);
  analytics.track("account login", { method: 'email', app: 'web', label: 'email' });
};

analyticsIntegrations.accountLogout = function() {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var properties = {};
  properties.category = "Account";
  analytics.track("account logout", properties);
  analytics.reset();
};

// Profiles
analyticsIntegrations.socialAccountFound = function(method, label) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var properties = {
    app: 'web'
  };
  properties.method = method;
  properties.label = label;
  analytics.track('social account found', properties);
};

analyticsIntegrations.socialEmailChanged = function(method, label) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var properties = {
    app: 'web'
  };
  properties.method = method;
  properties.label = label;
  analytics.track('social email changed', properties);
};

analyticsIntegrations.socialAccountLogin = function(method, label, ssoID) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var properties = {
    app: 'web'
  };
  properties.ssoID = ssoID;
  properties.category = "Account";
  properties.is_logged_in = true;
  properties.method = method;
  properties.label = label;
  analytics.identify(ssoID, properties);
  analytics.track('account login', properties);
};

analyticsIntegrations.resendVerification = function(){
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  analytics.track("resend verification", {
    verifying: "email"
  });
};

analyticsIntegrations.updateProfile = function(response){
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var profile = response.profile;
  var ssoId = profile.SSOid;
  var properties = {};
  properties.avatar = profile.avatar_url || null;
  properties.firstName = profile.first_name || null;
  properties.lastName = profile.last_name || null;
  properties.address = {postalCode: profile.zip || null};
  properties.phone = profile.phone || null;
  properties.title = profile.profession || null;
  properties.organization = profile.organization || null;
  analytics.identify(ssoId, properties);
};

analyticsIntegrations.reviewRequestWarningViewed = function(contract, riskData) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }

  var standardContractObj = analyticsIntegrations.normalizeContractObj(contract);
  var warningType = riskData.alcohol_consumed && riskData.is_late_night ?
    "late night with alcohol" : riskData.alcohol_consumed ?
    "has alcohol" : "late night";

  var riskObj = {
    warning_type: warningType,
    is_late_night: riskData.is_late_night,
    has_alcohol: riskData.alcohol_consumed
  };

  var mergedProperties = _.merge(standardContractObj, riskObj);

  analytics.track("review request warning viewed", mergedProperties);
};

analyticsIntegrations.bookingRequestDeclined = function(contract, declineReason, isOther, riskData) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var standardContractObj = analyticsIntegrations.normalizeContractObj(contract);

  analytics.track("booking request declined (frontend)", _.merge(standardContractObj, {
    decline_reason: declineReason,
    is_other: isOther,
    warning_type: riskData.warningType,
    is_late_night: riskData.is_late_night,
    has_alcohol: riskData.alcohol_consumed
  }));
};

analyticsIntegrations.customOfferFormViewed = function(booking, contract, isEditOffer, isHostUpdate){
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var standardBookingObj = analyticsIntegrations.normalizeBookingObj(booking);
  var standardListingObj = analyticsIntegrations.normalizeListingObj(_.get(booking, 'listing', {}));
  if (!_.isEmpty(contract)) {
    var standardContractObj = analyticsIntegrations.normalizeContractObj(contract);
    var mergedProperties = _.merge(standardListingObj, standardContractObj);
  } else {
    var mergedProperties = _.merge(standardListingObj, standardBookingObj);
  }
  mergedProperties.is_edit_offer = !!isEditOffer;
  mergedProperties.is_host_update = !!isHostUpdate;
  analytics.track("custom offer form viewed", mergedProperties);
};

analyticsIntegrations.customOfferStepCompleted = function(payload, completedStep, isEditOffer, isHostUpdate){
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  const properties = _.cloneDeep(payload);
  properties.step_completed = completedStep;
  properties.is_edit_offer = !!isEditOffer;
  properties.is_host_update = !!isHostUpdate;
  analytics.track("custom offer step completed", properties);
}

analyticsIntegrations.customOfferFormSubmitted = function(properties, booking, contract, isHostUpdate, isEditOffer){
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var standardBookingObj = analyticsIntegrations.normalizeBookingObj(booking);
  var standardListingObj = analyticsIntegrations.normalizeListingObj(_.get(booking, 'listing', {}));
  if (!_.isEmpty(contract)) {
    var standardContractObj = analyticsIntegrations.normalizeContractObj(contract);
    var mergedProperties = _.merge(standardListingObj, standardContractObj);
  } else {
    var mergedProperties = _.merge(standardListingObj, standardBookingObj);
  }
  var allProperties = _.merge(mergedProperties, properties)
  allProperties.current_booking_state = booking.obj_state;
  allProperties.is_edit_offer = !!isEditOffer;
  allProperties.is_host_update = !!isHostUpdate;
  analytics.track("custom offer form submitted", allProperties);
};

analyticsIntegrations.createItemFormViewed = function(eventName, props){
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  analytics.track(eventName, props);
};

analyticsIntegrations.createItemFormSubmitted = function(payload, isEditItem, fromManageAddons){
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  const properties = _.cloneDeep(payload);
  properties.is_edit_item = isEditItem;
  properties.origin = fromManageAddons ? 'Inventory' : 'Custom Offer';
  analytics.track(isEditItem ? "edit item form submitted" : "create item form submitted", properties);
};

analyticsIntegrations.reviewCustomOfferFormViewed = function(booking, contract){
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var standardBookingObj = analyticsIntegrations.normalizeBookingObj(booking);
  var standardListingObj = analyticsIntegrations.normalizeListingObj(_.get(booking, 'listing', {}));
  if (!_.isEmpty(contract)) {
    var standardContractObj = analyticsIntegrations.normalizeContractObj(contract);
    var mergedProperties = _.merge(standardListingObj, standardContractObj);
  } else {
    var mergedProperties = _.merge(standardListingObj, standardBookingObj);
  }
  analytics.track("review custom offer form viewed", mergedProperties);
};

analyticsIntegrations.acceptOfferConfirmed = function(booking){
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var standardBookingObj = analyticsIntegrations.normalizeBookingObj(booking);
  var standardListingObj = analyticsIntegrations.normalizeListingObj(_.get(booking, 'listing', {}));
  var mergedProperties = _.merge(standardListingObj, standardBookingObj);
  analytics.track("accept offer confirmed", mergedProperties);
};

analyticsIntegrations.acceptCustomOfferConfirmed = function(booking, contract, billing){
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var standardBookingObj = analyticsIntegrations.normalizeBookingObj(booking);
  var standardListingObj = analyticsIntegrations.normalizeListingObj(_.get(booking, 'listing', {}));
  if (!_.isEmpty(contract)) {
    var standardContractObj = analyticsIntegrations.normalizeContractObj(contract, 'accept');
    var mergedProperties = _.merge(standardListingObj, standardContractObj);
  } else {
    var mergedProperties = _.merge(standardListingObj, standardBookingObj);
  }

  if (_.get(billing, 'country')) {
    mergedProperties.guest_billing_country = billing.country;
    if (_.get(billing, 'state')) {
      mergedProperties.guest_billing_province = billing.state;
    }
  }

  mergedProperties.content_type = 'destination';
  mergedProperties.region = mergedProperties.state;

  analytics.track("accept custom offer confirmed", mergedProperties);
};

analyticsIntegrations.declineOfferConfirmed = function(booking, contract){
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var standardBookingObj = analyticsIntegrations.normalizeBookingObj(booking);
  var standardListingObj = analyticsIntegrations.normalizeListingObj(_.get(booking, 'listing', {}));
  if (!_.isEmpty(contract)) {
    var standardContractObj = analyticsIntegrations.normalizeContractObj(contract, 'decline');
    var mergedProperties = _.merge(standardListingObj, standardContractObj);
  } else {
    var mergedProperties = _.merge(standardListingObj, standardBookingObj);
  }
  analytics.track("decline offer confirmed", mergedProperties);
};

analyticsIntegrations.withdrawOfferConfirmed = function(bookingId){
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  analytics.track("withdraw offer confirmed", {booking_id: bookingId});
};

analyticsIntegrations.updateBookingFormViewed = function(booking, hostUpdate){
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var standardBookingObj = analyticsIntegrations.normalizeBookingObj(booking);
  var standardListingObj = analyticsIntegrations.normalizeListingObj(_.get(booking, 'listing', {}));
  var properties = _.merge(standardListingObj, standardBookingObj);
  var updatedBy = hostUpdate ? 'host' : 'guest';
  properties.label = `${updatedBy} requested update`;
  properties.update_requested_by = updatedBy;
  properties.max_capacity = properties.number_guests;
  delete properties.number_guests;
  delete properties.day_rate_set;
  analytics.track("update booking form viewed", properties);
};

analyticsIntegrations.updateBookingFormSubmitted = function(properties, booking, hostUpdate){
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var standardBookingObj = analyticsIntegrations.normalizeBookingObj(booking);
  var standardListingObj = analyticsIntegrations.normalizeListingObj(_.get(booking, 'listing', {}));
  var mergedProperties = _.merge(standardListingObj, standardBookingObj);
  var newProperties = _.merge(mergedProperties, properties);
  var updatedBy = hostUpdate ? 'host' : 'guest';
  newProperties.label = `${updatedBy} requested update`;
  newProperties.max_capacity = newProperties.number_guests;
  delete newProperties.number_guests;
  delete newProperties.day_rate_set;
  analytics.track("update booking form submitted", newProperties);
};

analyticsIntegrations.guestUpdateWithdraw = function(properties){
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  analytics.track("guest update withdrawn", properties);
 };

analyticsIntegrations.overtimeFormViewed = function(booking){
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var standardBookingObj = analyticsIntegrations.normalizeBookingObj(booking);
  var standardListingObj = analyticsIntegrations.normalizeListingObj(_.get(booking, 'listing', {}));
  var mergedProperties = _.merge(standardListingObj, standardBookingObj);
  mergedProperties.booking_end_time = JSON.stringify(booking.dts_end);
  analytics.track("overtime form viewed", mergedProperties);
};

analyticsIntegrations.overtimeFormSubmitted = function(booking, properties){
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var standardBookingObj = analyticsIntegrations.normalizeBookingObj(booking);
  var standardListingObj = analyticsIntegrations.normalizeListingObj(_.get(booking, 'listing', {}));
  var mergedProperties = _.merge(standardListingObj, standardBookingObj);
  mergedProperties.booking_end_time = JSON.stringify(booking.dts_end);
  var newProperties = _.merge(mergedProperties, properties);
  analytics.track("overtime form submitted", newProperties);
};

analyticsIntegrations.hostGuestIntent = function(ssoId, intent){
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var properties = {};
  properties.signup_intent = intent;
  analytics.identify(ssoId, properties);
};

analyticsIntegrations.whichModalOpened = function(whichModal){
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  analytics.page({
    title: whichModal,
    url: window.location.toString(),
    path: window.location.hash,
    referrer: document.referrer
  });
};

analyticsIntegrations.trackLinkClick = function (whichLink) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  analytics.track("link clicked", {
    category: "Account",
    label: whichLink,
    url: window.location.toString(),
    selection: whichLink
  });
};

analyticsIntegrations.keywordSearch = function (keyword, type) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  analytics.track("keyword search", {
    keyword: keyword,
    type: type
  });
};

analyticsIntegrations.moreFiltersClick = function () {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  analytics.track("'More Filters' opened");
};

analyticsIntegrations.failedHostReferral = function (referralCode) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  analytics.track('referral failed', {
    reason: 'user already exists',
    referral_code: referralCode,
    referral_type: 'host_referral',
    referral_user: PSSessions.Cookies('host-ref-promo-user-id') || 'none'
  });
};

analyticsIntegrations.trackAddServices = function (booking) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  analytics.track('Add Services', {
    origin: 'booking_requested', // this will be the source, currently only the post-booking request confirmation
    booking_id: booking._id,
    guest_id: booking.guest_id,
    listing_id: booking.listing_id,
    listing_metro: booking.listing.metro,
    use_type: booking.listing.use_type
  });
};

// Public Attendee Page
analyticsIntegrations.publicAttendee = function publicAttendee (trackerStr, propertiesObj) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  analytics.track(trackerStr, propertiesObj);
};

analyticsIntegrations.attendeeEdit = function (fieldName, fieldVal, bookingId) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var eventName = 'attendee details: ' + fieldName + ' edited';
  var val = 'object' === typeof fieldVal ? JSON.stringify(fieldVal) : fieldVal;
  var properties = {};
  properties.label = bookingId;
  properties[fieldName] = val;

  analytics.track(eventName, properties);
};

// Form Submits
analyticsIntegrations.formSubmit = function (formName) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  analytics.track('form attempt', { 'form name': formName });
};

analyticsIntegrations.formFail = function (formName, reason) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var eventName = 'form failure';
  analytics.track(eventName,
    { 'fail reason': reason || 'not provided',
      'request path': formName
    }
  );
};

analyticsIntegrations.requestFail = function (formName, reason) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var eventName = 'request failure';
  analytics.track(eventName,
    { 'fail reason': reason || 'not provided',
      'request path': formName
    }
  );
};

analyticsIntegrations.formSuccess = function (formName) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  analytics.track('form success', { 'form name': formName });
};

// Booking and Messages
analyticsIntegrations.inboxProductView = function (viewed, origin) {
  if (!analyticsIntegrations.segmentLoaded()) {return;}
  var properties = {};

  properties.origin = origin || analyticsIntegrations.getOrigin();
  properties.url = window.location.toString();
  properties.nonInteraction = 1;
  analytics.track(viewed, properties);
};

analyticsIntegrations.cancelBookingClicked = function (properties) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }

  analytics.track('Cancel Booking Clicked', properties);
}

analyticsIntegrations.cancelOptionsViewed = function (cancelProperties, contracts) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }

  const standardContractObj = analyticsIntegrations.normalizeContractObj(contracts);
  const payload = analyticsIntegrations.mergeObject(cancelProperties, standardContractObj);
  analytics.track('Cancellation Options Viewed', payload);
}

analyticsIntegrations.cancelBooking = function (action, cancelProperties) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }

  analytics.track(action, cancelProperties);
}

analyticsIntegrations.declineConfirmation = function (bookingId, reason) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  const properties = {};
  properties.decline_reason = reason;
  properties.booking_id = bookingId;
  properties.message = 'block-calendar'
  analytics.track('decline confirmation viewed', properties);
}

analyticsIntegrations.blockDayFormViewed = function (spaceId, ssoID, origin) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  const properties = {};
  properties.origin = origin;
  properties.space_id = spaceId;
  properties.created_by = ssoID;
  analytics.track('block day form viewed', properties);
}

analyticsIntegrations.blockDayFormSubmitted = function (payload) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  analytics.track('block day form submitted', payload);
}

analyticsIntegrations.calendarSync = function (event, spaceId, ssoID, origin, calendarType) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  const properties = {};
  properties.origin = origin;
  properties.space_id = spaceId;
  properties.created_by = ssoID;
  if (calendarType) properties.calendar_type = calendarType;
  analytics.track(event, properties);
}

// Variable Pricing
analyticsIntegrations.calendarPricingAction = function (eventType, properties = {}) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  analytics.track(eventType, properties);
}


// Instant Book
analyticsIntegrations.instantBookToggle = function (event, listing) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  const properties = {};
  properties.SSOid = listing.ownerId;
  properties.listing_id = listing._id;
  properties.listing_title = listing.title;
  properties.space_id = listing.parentSpaceId;
  properties.use_type = listing.use_type;
  properties.metro = listing.metro;
  analytics.track(event, properties);
}

// RSVP
analyticsIntegrations.rsvpEvent = function ({event, source, booking, currentStatus, previousStatus = null, method = null, dateModified = null, userId, profile, label }) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  const properties = {};
  properties.booking_id = booking._id;
  properties.invite_id = _.get(booking, 'pid');
  properties.source = source;
  properties.action = currentStatus;
  properties.prior_rsvp_status = previousStatus;
  properties.use_type = _.get(booking, 'listing.use_type');
  properties.page_type = 'invite';
  properties.metro = _.get(booking, 'listing.metro');
  properties.label = label;
  if (method) properties.method = method;
  if (userId) properties.user_id = userId;
  if ('signup verify email form submitted') properties.timestamp = dateModified;
  if ('account created' === event && profile) {
    const ssoId = profile.SSOid;
    const profileData = {
     id: ssoId,
     email: profile.username,
     createdAt: profile.date_created,
     is_logged_in: true
    }
    properties.context = {
      traits: profileData
    }
    analytics.alias(ssoId);
    analytics.identify(ssoId, profileData);
  }
  analytics.track(event, properties);
}

// SCHEDULE HELPERS

analyticsIntegrations.isolateStartTime = function (schedule, property) {
  return schedule.map(day => {
    return day[property];
  })
}

analyticsIntegrations.compareSchedulesByProperty = function (originalSchedule, newSchedule, property) {
  const originalProp = analyticsIntegrations.isolateStartTime(originalSchedule, property);
  const newProp = analyticsIntegrations.isolateStartTime(newSchedule, property);

  return !_.isEqual(originalProp, newProp);
}

// END OF SCHEDULE HELPERS

analyticsIntegrations.sendInvite = function (booking, payload, pageType, action) {
  const properties = {
    booking_id: booking._id,
    invite_id: booking.pid,
    metro: _.get(booking, 'listing.metro'),
    use_type: _.get(booking, 'listing.use_type'),
    user_id: _.get(booking, 'guest.ssoid'),
    action,
    page_type: pageType,
    emails_added: _.get(payload,'emails', []).length
  }

  analytics.track('attendee_details_invite_form_submitted', properties);
}

analyticsIntegrations.addDetailsInvite = function (booking, {
  guest_schedule: guestSchedule = [{}],
  guest_notes: guestNotes,
  guest_title: guestTitle
}, pageType) {

  const bookingSchedule = _.get(booking, 'schedule');
  const previousGuestSchedule = _.get(booking, 'public_fields.guest_schedule');
  const latestSchedule = (previousGuestSchedule || bookingSchedule);

  const properties = {
    booking_id: booking._id,
    invite_id: booking.pid,
    metro: _.get(booking, 'listing.metro'),
    use_type: _.get(booking, 'listing.use_type'),
    user_id: _.get(booking, 'guest.ssoid'),
    start_time_edited: analyticsIntegrations.compareSchedulesByProperty(latestSchedule, guestSchedule, 'start'),
    end_time_edited: analyticsIntegrations.compareSchedulesByProperty(latestSchedule, guestSchedule, 'end'),
    start_time_submitted: analyticsIntegrations.isolateStartTime(guestSchedule, 'start').map(startTime => {
        return JSON.stringify(startTime);
    }),
    end_time_submitted: analyticsIntegrations.isolateStartTime(guestSchedule, 'end').map(endTime => {
        return JSON.stringify(endTime);
    }),
    title_edited: guestTitle !== _.get(booking, 'public_fields.guest_title'),
    details_edited: guestNotes !== _.get(booking, 'public_fields.guest_notes'),
    page_type: pageType
  }

  analytics.track('attendee_details_edit_form_submitted', properties);
}

analyticsIntegrations.inboxInviteModalViewed = function (details = {}, userSsoId) {
  const properties = {
    booking_id: details.booking_id,
    invite_id: details.pid,
    metro: _.get(details, 'metro'),
    use_type: _.get(details, 'listing.use_type'),
    user_id: userSsoId
  };

  analytics.track('attendee_details_inbox_modal_viewed', properties);
};

analyticsIntegrations.inboxInviteModalClicked = function (details = {}, userSsoId) {
  const properties = {
    booking_id: details.booking_id,
    invite_id: details.pid,
    metro: _.get(details, 'metro'),
    use_type: _.get(details, 'listing.use_type'),
    user_id: userSsoId
  };

  analytics.track('attendee_details_inbox_modal_clicked', properties);
};

// Payments
analyticsIntegrations.payoutsExported= function (ssoId, formattedFrom, formattedTo) {
  const properties = {
    user_id: ssoId,
    start_date: formattedFrom,
    end_date: formattedTo
  };

  analytics.track('payouts_exported', properties);
};

// Production insurance
analyticsIntegrations.productionInsurancePageViewed = function (contracts) {
  const standardContractObj = analyticsIntegrations.normalizeContractObj(contracts);

  analytics.track('production insurance page viewed', standardContractObj);
};

analyticsIntegrations.productionInsuranceButtonClicked = function (contracts, buttonClicked) {
  const stdContractObj = analyticsIntegrations.normalizeContractObj(contracts);

  analytics.track(
    'production insurance button clicked',
    {
      ...stdContractObj,
      button_clicked: buttonClicked
    }
  )
}

analyticsIntegrations.bkgReqAddOnsStepViewed = function (contracts, listingObj, publicAddOns) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }

  const standardListingObj = analyticsIntegrations.normalizeListingObj(listingObj);
  const standardContractObj = analyticsIntegrations.normalizeContractObj(contracts, '', publicAddOns);

  var payload = analyticsIntegrations.mergeObject(standardContractObj, standardListingObj);

  // remove PII
  delete payload.profession;
  delete payload.organization;

  analytics.track('viewed bkg add on request form', payload);
}

analyticsIntegrations.bkgReqReviewStepViewed = function (
  contracts,
  listingObj,
  publicAddOns,
  additionalData = {}
) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }

  const standardListingObj = analyticsIntegrations.normalizeListingObj(listingObj);
  const standardContractObj = analyticsIntegrations.normalizeContractObj(contracts, '', publicAddOns);

  var payload = {
    ...analyticsIntegrations.mergeObject(standardContractObj, standardListingObj),
    ...additionalData
  };

  // remove PII
  delete payload.profession;
  delete payload.organization;

  analytics.track('viewed bkg review form', payload);
}

analyticsIntegrations.experimentLoaded = function (
  experimentName,
  variant,
  experimentId
) {
  if (!analyticsIntegrations.segmentLoaded()) {
    return;
  }
  const properties = {
    experiment_name: experimentName,
    experiment_variant: variant,
    experiment_id: experimentId
  };
  analytics.track('experiment loaded', properties);
};

analyticsIntegrations.reviewIdentityVerification = function ({viewed, clicked, booking_request_review, custom_offer_review, contracts, listingObj, publicAddOns, alcohol_consumed, schedule, riskScore}) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }

  const standardListingObj = analyticsIntegrations.normalizeListingObj(listingObj);
  const standardContractObj = analyticsIntegrations.normalizeContractObj(contracts, '', publicAddOns);

  var payload = _.merge({ clicked, viewed, booking_request_review, custom_offer_review, alcohol_consumed, schedule, riskScore }, standardContractObj, standardListingObj);
  // remove PII
  delete payload.profession;
  delete payload.organization;

  analytics.track('review identity verification', payload);
};

analyticsIntegrations.statusUpdateIdentityVerification = function (payload) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }

  analytics.track('status update identity verification', payload);
};

// Production Questions
analyticsIntegrations.productionQuestions = function (productionQuestionsPayload) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }

  analytics.track('production details submitted', productionQuestionsPayload);
}

// Listings carousel interaction tracking
analyticsIntegrations.photoCarouselInteraction = function (listingId, source) {
  if (!analyticsIntegrations.segmentLoaded()) {return;}
  const properties = {
    listing_id : listingId,
    source
  };
  properties.search_id = PSSessions.Cookies('search_id') || 'none';
  analytics.track('carousel viewed', properties);
}

analyticsIntegrations.splitPaymentToggled = function (metaData) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }

  analytics.track('split_toggled', metaData);
};

analyticsIntegrations.splitPaymentCheckout = function (metaData) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }

  analytics.track('split_checkout', metaData);
};

analyticsIntegrations.splitFailFullCheckoutSuccess = function (metaData) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }

  analytics.track('split_fail_full_success', metaData);
};

analyticsIntegrations.buttonClicked = function (properties = {}) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  analytics.track('button clicked', properties);
}

// Calendar Sync Host Survey
analyticsIntegrations.calSyncSurveyViewed = function (space_id, host_id, step_viewed) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  const properties = {
    space_id,
    host_id,
    step_viewed
  };
  analytics.track('cal sync survey viewed', properties);
};

// Attachments Painted Door Survey
analyticsIntegrations.attachmentsSurvey = function (event, properties = {}) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  analytics.track(event, properties);
}

analyticsIntegrations.guestSocialEventPolicyCheckedYes = function (masterContract, spaceRentalContract, schedule, riskScore) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }

  const listingId = _.get(spaceRentalContract, 'meta.booking.listing_id');
  const guestId = _.get(spaceRentalContract, 'meta.booking.guest_id');
  const bookingPrice = _.get(masterContract, 'calculations.guest.payment');
  const spaceType = _.get(spaceRentalContract, 'meta.listing.space_type_tag');
  const activityType = _.get(spaceRentalContract, 'meta.booking.tags.activity');
  const numberOfGuests = _.get(spaceRentalContract, 'meta.booking.number_of_guests');

  const properties = {
    listing_id: listingId,
    guest_id: guestId,
    booking_price: bookingPrice,
    schedule,
    space_type: spaceType,
    activity_type: activityType,
    risk_score: riskScore,
    number_of_guests: numberOfGuests
  };

  analytics.track('guest social events policy agreement checked yes', properties);
};

// Loading Functions
analyticsIntegrations.mainFunctionsLoad = function(){
  analyticsIntegrations.bugsnagDetails();
};
loadSegmentProfilePage = function() {
  analyticsIntegrations.mainFunctionsLoad();
  analyticsIntegrations.addShareEventListeners();
  analyticsIntegrations.addListingBlockEventListeners();
  analyticsIntegrations.addNavFooterListeners();
};
loadSegmentListingPage = function(){
  analyticsIntegrations.mainFunctionsLoad();
  analyticsIntegrations.addShareEventListeners();
  analyticsIntegrations.listingsProductView(listingJSON);
  analyticsIntegrations.addNavFooterListeners();
};
loadSegmentUsePage = function(){
  analyticsIntegrations.mainFunctionsLoad();
  analyticsIntegrations.addNavFooterListeners();
  analyticsIntegrations.addListingBlockEventListeners();
  analyticsIntegrations.heroSectionEventListener();
  analyticsIntegrations.conciergeSectionListener();
  analyticsIntegrations.bannerSectionEventListener();
};
loadSegmentCollectionsPage = function(){
  analyticsIntegrations.mainFunctionsLoad();
  analyticsIntegrations.addShareEventListeners();
  analyticsIntegrations.addListingBlockEventListeners();
  analyticsIntegrations.collectionThumbnailEventListener();
  analyticsIntegrations.addNavFooterListeners();
};
loadSegmentMarketingPage = function(){
  analyticsIntegrations.mainFunctionsLoad();
  analyticsIntegrations.collectionThumbnailEventListener();
  analyticsIntegrations.addNavFooterListeners();
  analyticsIntegrations.heroSectionEventListener();
  analyticsIntegrations.bannerSectionEventListener();
  analyticsIntegrations.learnMoreSectionEventListener();
  analyticsIntegrations.eventPlanningSectionEventListener();
  analyticsIntegrations.joinUsEventListener();
  analyticsIntegrations.searchEventListener();
};
window.loadSegmentSearchPage = function(){
  analyticsIntegrations.mainFunctionsLoad();
};
